<template>
  <v-dialog v-model="dialog" persistent max-width="300">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
        <template v-slot:activator="{ on: tooltip, attrs }">
          <img
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
            class="remove-icon"
            src="@/assets/images/Remove.svg" />
        </template>
        <span>Delete</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="card-title">Delete Request</v-card-title>
      <v-card-text>
        Are you sure want to
        <strong>DELETE</strong> record?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="disAgree">Disagree</v-btn>
        <v-btn color="green darken-1" text @click="agree">Agree</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UserService } from "@/services";

export default {
  name: "DeleteComponent",
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    id: String,
    module: String,
  },
  methods: {
    async agree() {
      this.dialog = false;
      const response = await UserService.deleteRequest({
        module: this.module,
        id: this.id,
      });
      if (response) {
        this.$emit("requestDeleted", this.id);
        this.$store.dispatch("user/setSnack", "Record deleted successfully!");
        this.$store.dispatch("user/setType", "info");
      }
    },
    disAgree() {
      this.dialog = false;
    },
  },
};
</script>
